import React, { FC, KeyboardEvent, useState } from 'react';
import { Chip, TextField, TextFieldProps } from '@mui/material';
import { Controller, get, useFormContext } from 'react-hook-form';
import {
  ChipsContainer,
  MultiValueFormControl,
} from 'src/components/Forms/FormInputs/styled';

interface RegionSearchInputProps {
  name: string;
  placeholder?: string;
  helperText?: string;
}

export const RegionSearchInput: FC<RegionSearchInputProps & TextFieldProps> = ({
  name,
  placeholder = 'Digita e premi Invio...',
  helperText,
  ...props
}) => {
  const [inputValue, setInputValue] = useState('');
  const {
    control,
    formState: { errors },
  } = useFormContext();

  const error = get(errors, name);

  const handleDelete = (
    index: number,
    value: string[],
    onChange: (value: string[]) => void,
  ) => {
    const newValue = value.filter((_, i) => i !== index);
    onChange(newValue);
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(event.target.value);
  };

  const handleKeyDown = (
    e: KeyboardEvent<HTMLDivElement>,
    value: string[],
    onChange: (value: string[]) => void,
  ) => {
    if (e.key === 'Enter' && inputValue.trim() !== '') {
      e.preventDefault();
      const newValue = [...value, inputValue.trim()];
      setInputValue('');
      onChange(newValue);
    }
  };

  const handleBlur = (value: string[], onChange: (value: string[]) => void) => {
    if (inputValue.trim() !== '') {
      const newValue = [...value, inputValue.trim()];
      setInputValue('');
      onChange(newValue);
    }
  };

  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { onChange, value } }) => (
        <MultiValueFormControl error={!!error?.message}>
          <ChipsContainer>
            {value?.map((item: string, index: number) => (
              <Chip
                key={index}
                size="small"
                variant="outlined"
                label={item}
                onDelete={() => handleDelete(index, value, onChange)}
              />
            ))}
            <TextField
              {...props}
              placeholder={placeholder}
              autoComplete="off"
              value={inputValue}
              onChange={handleChange}
              onKeyDown={(event) => handleKeyDown(event, value || [], onChange)}
              onBlur={() => handleBlur(value || [], onChange)}
              helperText={
                helperText || (error?.message ? error.message : undefined)
              }
              sx={{
                '& .MuiInputBase-input::placeholder': {
                  color: 'rgba(0, 0, 0, 0.7)',
                  opacity: 1,
                },
                '& .MuiFormHelperText-root': {
                  color: 'rgba(0, 0, 0, 0.7)',
                  fontSize: '12px',
                },
              }}
              fullWidth
              size="small"
            />
          </ChipsContainer>
        </MultiValueFormControl>
      )}
    />
  );
};
